import Button from '@jetbrains/ring-ui/components/button/button'
import Code from '@jetbrains/ring-ui/components/code/code'

import {restApi} from '../../../../services/rest'
import {extractError} from '../../../../utils/extractError'

import styles from './GenerateToken.css'

export default function GenerateToken() {
  const [generate, {data, inited, error, loading}] =
    restApi.endpoints.generateAgentToken.useMutation({
      selectFromResult: ({data, isUninitialized, error, isLoading}) => ({
        data,
        inited: !isUninitialized,
        error,
        loading: isLoading,
      }),
    })
  const extractedError = extractError(error)

  return (
    <div>
      <p>{'Copy and save the token after generating it.'}</p>
      <Button loader={loading} onClick={() => generate()} primary>
        {'Generate'}
      </Button>
      {!loading && (
        <div className={styles.result}>
          {error != null ? (
            <div className={styles.error}>
              {typeof extractedError === 'string' ? extractedError : extractedError?.message}
            </div>
          ) : (
            inited &&
            (data != null && data.length > 0 ? (
              <Code code={data} className={styles.code} softWrap />
            ) : (
              <div className={styles.empty}>{'Empty token'}</div>
            ))
          )}
        </div>
      )}
    </div>
  )
}
